export default __webpack_public_path__ + "static/media/jonathan.8eb7193f.png";